module.exports = "/_next/static/images/858ff3a4122d55fe3a368d6fcb810c01-prepayment_example.png.webp";